<template>
  <div class="page-tabbar">
    <mt-header :title="current_tab" fixed>
      <mt-button v-if="show_help" slot="left" icon="back" @click="closeHelp">
        返回
      </mt-button>
      <mt-button v-else slot="left" @click="close">
        关闭
      </mt-button>
    </mt-header>
    <div class="page-wrap" v-if="hasLogin">
      <mt-tab-container class="page-tabbar-container" v-model="current_tab">
        <mt-tab-container-item id="维护">
          <to-do> </to-do>
        </mt-tab-container-item>
        <mt-tab-container-item id="点位">
          <state> </state>
        </mt-tab-container-item>
        <mt-tab-container-item id="申请耗材">
          <apply> </apply>
        </mt-tab-container-item>
        <mt-tab-container-item id="个人中心">
          <me> </me>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>

    <mt-tabbar v-model="current_tab" fixed>
      <mt-tab-item id="维护">
        维护
      </mt-tab-item>
      <mt-tab-item id="点位">
       点位
      </mt-tab-item>
      <mt-tab-item v-if="isSchool"  id="申请耗材">
        申请耗材
      </mt-tab-item>
      <mt-tab-item id="个人中心">
        个人中心
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import toDo from "@/views/Home/children/ToDo";
import apply from "@/views/Home/children/Apply";
import me from "@/views/Home/children/Me";
import state from "@/views/Home/children/State";
import { getIsSchool } from "../../service";
import store from "store";

export default {
  name: "home",
  data() {
    return {
        isSchool: false,
      // loginded: '个人中心'
      //   current_tab: '维护'
    };
  },
  components: {
    toDo,
    apply,
      state,
    me
  },
  methods: {
    ...mapMutations({
      recordUser: "user/recordUser",
      changeHelp: "tab/changeHelp",
      changeTab: "tab/changeTab"
    }),
    closeHelp() {
      this.changeHelp(false);
    },
    close() {
      WeixinJSBridge.invoke("closeWindow");
      // wx.closeWindow();
    }
  },
  created() {
    const userInfo = store.get("storeUser");
    if (userInfo) {
      this.recordUser(userInfo);
        getIsSchool(userInfo.user.tel).then(({ status, data: { code, data } }) => {
            if (status === 200 && code === 0) {
                this.isSchool = data.isSchool
            }
        })
    } else {
      this.$router.push("/operation/login");
    }
  },
  computed: {
    ...mapState({
      current: state => state.tab.current_tab,
      show_help: state => state.tab.show_help,
      user: state => state.user.userInfo,
      hasLogin: state => state.user.hasLogin,
    }),
    current_tab: {
      get() {
        return this.current;
      },
      set(tab) {
        this.changeTab(tab);
      }
    }
  }
};
</script>

<style>
.page-tabbar .mint-tab-item-label {
  line-height: 1.8;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue